import { Layer } from '@/components/LayeringEngine/LayeringEngine.models';
import { Floor, Module } from '../api';
import { ResponsiveImageDimensions } from '@/components/utils/ResponsiveImage/ResponsiveImage.models';
import generateITSMedia from '@/utils/helpers/generateITSMedia';

export default (floor: Floor, mediaDimenstions: ResponsiveImageDimensions): Layer[] => {
  const layers: Layer[] = [];

  floor.additionalImages?.forEach(additionalImage => {
    layers.push({
      ID: additionalImage,
      alt: floor.name,
      media: generateITSMedia(additionalImage, mediaDimenstions)
    });
  });

  floor.zones.forEach(zone => {
    if (zone.zones?.length) {
      zone.zones.some(subZone => {
        const selectedModule: Module | undefined = subZone.modules?.find(module => module.isSelected);

        if (selectedModule) {
          layers.push({
            ID: zone.ID,
            alt: selectedModule.name,
            media: generateITSMedia(selectedModule.image, mediaDimenstions)
          });

          return true;
        } else {
          return false;
        }
      });
    } else if (zone.modules?.length) {
      const selectedModule: Module | undefined = zone.modules.find(module => module.isSelected);

      if (selectedModule) {
        layers.push({
          ID: zone.ID,
          alt: selectedModule.name,
          media: generateITSMedia(selectedModule.image, mediaDimenstions)
        });
      }
    }
  });

  return layers;
};
